import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';

const ProtocolLink = ({ $app, protocol, children, ...rest }) => {
  if ($app.isSubtenant) {
    return children;
  }
  return (
    <Link to={`/v4/core/quick-views/protocol/${protocol}`} {...rest}>
      {children}
    </Link>
  );
};

export default inject('$app')(ProtocolLink);
